<template>
  <div>


<h2 class="goth">Prepositioner som styr dativ</h2>


<div class="grammatikparagrafbredd leftorient">


<p>Efter följande prepositioner står substantivet eller pronomenet alltid i dativ</p>

<table class="">


    <tr class="leftorient">
        <td class="vit bgrod"><b>aus</b></td>
        <td class="vit bgrod">ur, från, av</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>außer</b></td>
        <td class="vit bgrod">utom, förutom</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>bei</b></td>
        <td class="vit bgrod">vid, hos</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>gegenüber</b></td>
        <td class="vit bgrod">mittemot, gentemot</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>mit</b></td>
        <td class="vit bgrod">med</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>nach</b></td>
        <td class="vit bgrod">efter, till, enligt</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>seit</b></td>
        <td class="vit bgrod">sedan, alltsedan</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>von</b></td>
        <td class="vit bgrod">från, av, om</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgrod"><b>zu</b></td>
        <td class="vit bgrod">zu</td>
    </tr>


</table>


<br>
<div class="ruta">

<p><i>Lisa kommt <b>aus der</b> Schweiz.<div class="minitext">(grundform: 'die Schweiz')</div> </i><br>
Lisa kommer från Schweiz.</p>

<p><i>Wir sind alle <b>außer deiner</b> Schwester da.</i><br>
Vi är alla här utom din syster.</p>

<p><i>Kann ich <b>bei dir</b> übernachten?</i><br>
Kan jag övernatta hos dig?</p>

<p><i>Die Schule liegt <b>gegenüber der</b> Bibliothek.</i><br>
Skolan ligger mittemot biblioteket.</p>

<p><i><b>Mit diesem</b> Vorschlag können wir weiter gehen.</i><br>
Med detta förslag kan vi gå vidare.</p>

<p><i><b>Nach</b> zwei Tage<b>n</b> kommen wir zurück.</i><br>
Efter två dagar kommer vi tillbaka.</p>

<p><i><b>Seit einer</b> Stunde warten wir noch.</i><br>
Vi har redan väntat i en timme.</p>

<p><i>Kalle spricht <b> von seinem</b> Geburtstag.</i><br>
Kalle pratar om sin födelsedag.</p>

<p><i>Morgen fahren wir früh <b>zur</b> Schule.</i><br>
Imorgon åker vi tidigt till skolan.</p>


</div>


<br><br>






</div>

<h4 class="grammatikparagrafbredd leftorient">Bestämd artikel i dativ</h4><br>


    <table class="">

        <tr class="leftorient">
            <td></td>
            <td class="ljusgra">mask.</td>
            <td class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>
            <td class="ljusgra">plur.</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="vit bgbla">der</td>
            <td class="vit bgbla">das</td>
            <td class="vit bgbla">die</td>
            <td class="vit bgbla">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">dat.</td>
            <td class="vit bgrod"><b>dem</b></td>
            <td class="vit bgrod"><b>dem</b></td>
            <td class="vit bgrod"><b>der</b></td>
            <td class="vit bgrod"><b>den ..n</b></td>
        </tr>

    </table>
    <br>
<p class="grammatikparagrafbredd leftorient">Ord som <i>dieser, dieses, diese</i> böjs på liknande sätt
    (blir alltså <i><b>diesem, diesen, dieser</b></i> i dativ maskulinum, neutrum respektive femininum).</p>
<br><br>

<div class="quasi-p inramad leftorient">Oftast skrivs preposition och artikel ihop till ett ord i följande fall:<br>

<nobr><i>bei+dem=<b>beim</b></i></nobr>
&nbsp;&nbsp;<nobr><i>von+dem=<b>vom</b></i></nobr>
&nbsp;&nbsp;<nobr><i>zu+dem=<b>zum</b></i></nobr>
&nbsp;&nbsp;<nobr><i>zu+der=<b>zur</b></i></nobr></div>


<br><br><br>



    <h4 class="grammatikparagrafbredd leftorient">Obestämd artikel i dativ</h4><br>


        <table class="">

            <tr class="leftorient">
                <td></td>
                <td class="ljusgra">mask.</td>
                <td class="ljusgra">neutr.</td>
                <td class="ljusgra">fem.</td>

            </tr>

            <tr class="leftorient">
                <td class="ljusgra">nom.</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">eine</td>

            </tr>

            <tr class="leftorient">
                <td class="ljusgra">dat.</td>
                <td class="vit bgrod"><b>einem</b></td>
                <td class="vit bgrod"><b>einem</b></td>
                <td class="vit bgrod"><b>einer</b></td>

            </tr>

        </table>
<br>
<p class="grammatikparagrafbredd leftorient">Ord som <i>mein, dein, kein, ihr</i> o.s.v. böjs på liknande sätt
    (blir alltså t.ex. <i><b>meinem, deinem, keinem, ihrem</b></i> o.s.v. i dativ maskulinum).</p>

<br>



<br><br>

<br>
<h4 class="grammatikparagrafbredd leftorient">Personliga pronomen i dativ</h4><br>
<table class="">

    <tr class="leftorient">
        <td class="ljusgra">svenska</td>
        <td class="ljusgra">nominativ</td>
        <td class="ljusgra">dativ</td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">jag / mig</td>
        <td class="vit bgbla">ich</td>
        <td class="vit bgrod"><b>mir</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">du / dig</td>
        <td class="vit bgbla">du</td>
        <td class="vit bgrod"><b>dir</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">han / honom<br>det / det<br>hon / henne</td>
        <td class="vit bgbla">er<br>es<br>sie</td>
        <td class="vit bgrod"><b>ihm<br>ihm<br>ihr</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">vi / oss</td>
        <td class="vit bgbla">wir</td>
        <td class="vit bgrod"><b>uns</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">ni / er</td>
        <td class="vit bgbla">ihr</td>
        <td class="vit bgrod"><b>euch</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">de / dem<br>Ni / Er</td>
        <td class="vit bgbla">sie<br>Sie</td>
        <td class="vit bgrod"><b>ihnen<br>Ihnen</b></td>
    </tr>




</table>


<br>

<div class="mindre quasi-p leftorient">När ett ord står i dativ efter något av prepositionerna
    <i>aus, außer, bei, gegenüber, mit, nach, seit , von, zu </i> kallas satsdelen
<b><i>prepositionsobjekt i dativ</i></b> och skall inte förväxlas med <i>dativobjekt</i></div>



</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "prepositioner som styr dativ"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
